import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { SolutionSection } from '../components/SolutionSection';
import { ToolSavingsSection } from '../components/ToolSavingsSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { ConsultCTA } from '../components/ConsultCTA';
import { PricingSection } from '../components/PricingSection';
import { OnboardingSection } from '../components/OnboardingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-227">
      <Hero data-id="element-228" />
      <ProblemSection data-id="element-229" />
      <BeforeAfterSection data-id="element-230" />
      <SolutionSection data-id="element-231" />
      <ToolSavingsSection data-id="element-232" />
      <CaseStudySection data-id="element-233" />
      <ConsultCTA variant="dark" data-id="element-234" />
      <PricingSection data-id="element-235" />
      <OnboardingSection data-id="element-236" />
      <FAQSection data-id="element-237" />
      <ConsultCTA variant="light" data-id="element-238" />
      <Footer data-id="element-239" />
    </div>;
}